<template>
  <v-dialog v-model="dialog" persistent max-width="600px" min-width="360px">
    <div>
      <v-tabs v-model="tab" show-arrows background-color="teal" icons-and-text dark grow>
        <v-tab v-for="i in tabs" :key="i.name">
          <v-icon large>{{ i.icon }}</v-icon>
          <div class="caption py-1">{{ i.name }}</div>
        </v-tab>
        <v-tab-item>
          <v-card class="px-4">
            <v-card-text>
              <v-form ref="loginForm" v-model="valid" lazy-validation>
                <v-row>
                  <v-col v-if="showPasswordResetRequest" cols="12">
                    <v-text-field v-model="loginEmail" :rules="loginEmailRules" label="E-mail" required></v-text-field>
                  </v-col>
                  <v-col cols="12" v-if="authError" align="center">
                    <v-chip color="red" outlined label>Username or password is incorrect!</v-chip>
                  </v-col>
                  <v-col v-if="!showPasswordResetRequest && !showPasswordReset" cols="12">
                    <v-text-field v-model="loginUsername" :rules="[rules.required, rules.min]" label="Username" required></v-text-field>
                  </v-col>
                  <v-col v-if="!showPasswordResetRequest && !showPasswordReset" cols="12">
                    <v-text-field v-model="loginPassword" :append-icon="show1?'eye':'eye-off'" :rules="[rules.required, rules.min]" :type="show1 ? 'text' : 'password'" name="input-10-1" label="Password" hint="At least 6 characters" counter @click:append="show1 = !show1"></v-text-field>
                  </v-col>
                  <v-col v-if="showPasswordChange && !showPasswordResetRequest" cols="12">
                    <v-text-field v-model="newLoginPassword" :append-icon="show1?'eye':'eye-off'" :rules="[rules.required, rules.min]" :type="show1 ? 'text' : 'password'" name="input-10-1" label="New Password" hint="At least 6 characters" counter @click:append="show1 = !show1"></v-text-field>
                  </v-col>
                  <v-col v-if="showPasswordReset" cols="12">
                    <v-text-field v-model="newLoginPasswordToken" name="input-10-1" label="Reset Token" hint="Sent via Email"></v-text-field>
                  </v-col>
                  <v-spacer></v-spacer>
                  <v-col class="d-flex" cols="6" align-start>
                    <v-btn block @click="dialog=false; $router.back()">Cancel</v-btn>
                  </v-col>
                  <v-col v-if="!showPasswordResetRequest" class="d-flex ml-auto" cols="6">
                    <v-btn block :disabled="!valid" color="success" @click="validate">Login</v-btn>
                  </v-col>
                  <v-col v-if="showPasswordResetRequest" class="d-flex ml-auto" cols="6">
                    <v-btn block :disabled="!valid" color="success" @click="sendPasswordResetToken">Send Reset Code</v-btn>
                  </v-col>
                </v-row>
<!--                <v-row>-->
<!--                  <v-col align="end" @click="togglePasswordChange"><a>Change Password</a></v-col>-->
<!--                  <v-col><a @click="togglePasswordReset">Forgot Password</a></v-col>-->
<!--                </v-row>-->
              </v-form>
            </v-card-text>
          </v-card>
        </v-tab-item>
        <v-tab-item>
          <v-card class="px-4">
            <v-card-text>
              <v-form ref="registerForm" v-model="valid" lazy-validation>
                <v-row>
                  <v-col cols="12" sm="6" md="6">
                    <v-text-field v-model="firstName" :rules="[rules.required]" label="First Name" maxlength="20" required></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="6" md="6">
                    <v-text-field v-model="lastName" :rules="[rules.required]" label="Last Name" maxlength="20" required></v-text-field>
                  </v-col>
                  <v-col cols="12">
                    <v-text-field v-model="email" :rules="emailRules" label="E-mail" required></v-text-field>
                  </v-col>
                  <v-col cols="12">
                    <v-text-field v-model="password" :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'" :rules="[rules.required, rules.min]" :type="show1 ? 'text' : 'password'" name="input-10-1" label="Password" hint="At least 6 characters" counter @click:append="show1 = !show1"></v-text-field>
                  </v-col>
                  <v-col cols="12">
                    <v-text-field block v-model="verify" :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'" :rules="[rules.required, passwordMatch]" :type="show1 ? 'text' : 'password'" name="input-10-1" label="Confirm Password" counter @click:append="show1 = !show1"></v-text-field>
                  </v-col>
                  <v-spacer></v-spacer>
                  <v-col class="d-flex" cols="6" align-start>
                    <v-btn block @click="dialog=false; $router.back()">Cancel</v-btn>
                  </v-col>
                  <v-col class="d-flex ml-auto" cols="6">
                    <v-btn block :disabled="!valid" color="success" @click="validate">Register</v-btn>
                  </v-col>
                </v-row>
              </v-form>
            </v-card-text>
          </v-card>
        </v-tab-item>
      </v-tabs>
    </div>
  </v-dialog>
</template>

<script>

import {eSailServerPublic} from "@/plugins/axios";

export default {
  data: () => ({
    dialog: true,
    tab: 0,
    tabs: [
      {name:"Login", icon:"mdi-account"},
      // {name:"Register", icon:"mdi-account-outline"}
    ],
    valid: true,
    authError: false,

    firstName: "",
    lastName: "",
    email: "",
    password: "",
    verify: "",
    loginPassword: "",
    newLoginPassword: "",
    newLoginPasswordToken: "",
    loginUsername: "",
    loginEmail: "",
    loginEmailRules: [
      v => !!v || "Required",
      v => /.+@.+\..+/.test(v) || "E-mail must be valid"
    ],
    emailRules: [
      v => !!v || "Required",
      v => /.+@.+\..+/.test(v) || "E-mail must be valid"
    ],

    show1: false,
    showPasswordChange: false,
    showPasswordResetRequest: false,
    showPasswordReset: false,
    rules: {
      required: value => !!value || "Required.",
      min: v => (v && v.length >= 2) || "Min 2 characters"
    }
  }),
  computed: {
    passwordMatch() {
      return () => this.password === this.verify || "Password must match";
    }
  },
  methods: {
    validate() {
      if (this.$refs.loginForm.validate()) {
        if (this.showPasswordReset === true) {
          eSailServerPublic.post('registration/reset-password',
              { token: this.newLoginPasswordToken, newPassword: this.newLoginPassword
              })
              .then(() => this.login(this.loginEmail, this.newLoginPassword))
        } else if (this.showPasswordChange === true) {
          eSailServerPublic.post('registration/change-password',
              { username: this.loginUsername, currentPassword: this.loginPassword, newPassword: this.newLoginPassword })
              .then(() => this.login(this.loginUsername, this.newLoginPassword))
        } else {
          this.login(this.loginUsername, this.loginPassword)
        }
      }
    },
    login(username, password) {
      this.$auth.login({
        data: {
          username: username,
          password: password
        },
        redirect: 'home'
      })
          .then(() => this.dialog = false)
          .catch(() => this.authError = true)
    },
    reset() {
      this.$refs.form.reset();
    },
    resetValidation() {
      this.$refs.form.resetValidation();
    },
    togglePasswordChange() {
      this.showPasswordChange = true
      this.showPasswordResetRequest = false
    },
    togglePasswordReset() {
      this.showPasswordChange = false
      this.showPasswordResetRequest = true
    },
    sendPasswordResetToken() {
      if (this.$refs.loginForm.validate()) {
        eSailServerPublic.get('registration/reset-password?email=' + this.loginEmail)
        this.showPasswordResetRequest = false
        this.showPasswordChange = true
        this.showPasswordReset = true
      }
    }
  }
};

</script>

<style scoped>

</style>